<!-- 区域建筑名 厂商信息管理 料工清单-->
<nz-table #simpleTable [nzScroll]="nzScroll" [nzData]="listOfData" nzSize="small" nzShowSizeChanger nzBordered
  *ngIf="listOfData">
  <thead>
    <tr>
      <th scope="col" [nzChecked]="checked" [nzIndeterminate]="indeterminate" (nzCheckedChange)="onAllChecked($event)"
        nzWidth="2%">
      </th>
      <th scope="col" nzWidth="3%">{{ 'Common.No' | translate }}</th>
      <ng-container *ngFor="let column of formItems">
        <ng-container [ngSwitch]="column.value">
          <th scope="col" *ngSwitchCase="'pn'" nzLeft>{{ column.text | translate }}</th>
          <th scope="col" *ngSwitchDefault>{{ column.text | translate }}</th>
        </ng-container>
      </ng-container>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of simpleTable.data">
      <td *ngIf="needCheck" (nzCheckedChange)="onItemChecked(data.id, $event)"
        [nzChecked]="setOfCheckedId.has(data.id)"></td>
      <!-- 序号 -->
      <td>{{listOfData.indexOf(data)+1}}</td>
      <ng-container *ngFor="let column of formItems">
        <ng-container [ngSwitch]="column.value">
          <!-- If是带有编辑功能的列;else其他列则直接输出对应的值 -->
          <ng-container *ngSwitchCase="'operation'">
            <td><a (click)="editRow.emit(data)">{{ 'BaseData.Edit' | translate }}</a></td>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <td nzBreakWord>{{ data[column.value] }}</td>
          </ng-container>
        </ng-container>
      </ng-container>
    </tr>
  </tbody>
</nz-table>